import { css } from '@emotion/css';

export const CreateFeedbackRequestModalStyles = css`
  max-height: min(72rem, calc(100vh - 15.6rem));
  min-height: min(72rem, calc(100vh - 15.6rem));
`;
